<img class="logo zero-state-image"
	alt="loading"
	src="https://staticassets.goreact.com/logo-goreact-spot-2022.svg"
	[style.width]="width"
	[style.height]="height"/>
